<template>
  <div>
    <!-- Input Continue button -->
    <div class="form-group row">
      <label for="continue_button" class="col-sm-10 control-label">{{ $t('ct-checkout-continue-button-label') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" :class="{'is-invalid': e.has('continue_button')}" id="continue_button" name="continue_button" @input="e.remove('continue_button')" v-model="config.texts.continue_button" maxlength="40">
        <small class="form-text text-danger" v-if="e.has('continue_button')">{{ e.first('continue_button') }}</small>
      </div>
    </div>
    <!-- Input Security Title -->
    <div class="form-group row">
      <label for="security_title" class="col-sm-10 control-label">{{ $t('ct-checkout-security-title-label') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" :class="{'is-invalid': e.has('security_title')}" id="security_title" name="security_title" @input="e.remove('security_title')" v-model="config.texts.security_title" maxlength="40">
        <small class="form-text text-danger" v-if="e.has('security_title')">{{ e.first('security_title') }}</small>
      </div>
    </div>
    <!-- Input Security Text -->
    <div class="form-group row">
      <label for="security_text" class="col-sm-10 control-label">{{ $t('ct-checkout-security-content-label') }}</label>
      <div class="col-sm-10">
        <textarea type="text" class="form-control" id="security_text" name="security_text" @input="e.remove('security_text')" v-model="config.texts.security_text" :class="{'is-invalid': e.has('security_text')}" maxlength="132"></textarea>
        <small class="form-text text-danger" v-if="e.has('security_text')">{{ e.first('security_text') }}</small>
      </div>
    </div>

    <!-- Input Payment button text -->
    <div class="form-group row">
      <label for="payment_button" class="col-sm-10 control-label">{{ $t('ct-checkout-payment-button-label') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" :class="{'is-invalid': e.has('payment_button')}" id="payment_button" name="payment_button" @input="e.remove('payment_button')" v-model="config.texts.payment_button" maxlength="40">
        <small class="form-text text-danger" v-if="e.has('payment_button')">{{ e.first('payment_button') }}</small>
        <span class="help-inline">{{ $t('ct-checkout-payment-button-help') }}</span>
      </div>
    </div>

    <!-- Input Thank You Title -->
    <div class="form-group row">
      <label for="thank_you_title" class="col-sm-10 control-label">{{ $t('ct-checkout-thankyou-title-label') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" :class="{'is-invalid': e.has('thank_you_title')}" id="thank_you_title" name="thank_you_title" @input="e.remove('thank_you_title')" v-model="config.texts.thank_you_title" maxlength="40">
        <small class="form-text text-danger" v-if="e.has('thank_you_title')">{{ e.first('thank_you_title') }}</small>
      </div>
    </div>

    <!-- Input Thank You Text -->
    <div class="form-group row">
      <label for="thank_you_text" class="col-sm-10 control-label">{{ $t('ct-checkout-thankyou-text-label') }}</label>
      <div class="col-sm-10">
        <textarea type="text" class="form-control" :class="{'is-invalid': e.has('thank_you_text')}" id="thank_you_text" name="thank_you_text" @input="e.remove('thank_you_text')" v-model="config.texts.thank_you_text" rows="4" maxlength="2048"></textarea>
        <small class="form-text text-danger" v-if="e.has('thank_you_text')">{{ e.first('thank_you_text') }}</small>
      </div>
    </div>

    <!-- Input Get Product -->
    <div class="form-group row">
      <label for="get_product_button" class="col-sm-10 control-label">{{ $t('ct-checkout-thankyou-get-product-button-label') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" :class="{'is-invalid': e.has('get_product_button')}" id="get_product_button" name="get_product_button" @input="e.remove('get_product_button')" v-model="config.texts.get_product_button" maxlength="40">
        <small class="form-text text-danger" v-if="e.has('get_product_button')">{{ e.first('get_product_button') }}</small>
      </div>
    </div>

    <!-- Form Submit -->
    <div class="form-group row">
      <div class="col-sm-offset-2 col-sm-10">
        <button type="reset" @click="$emit('cancel')" class="btn btn-outline-info btn-small">{{ $t('ct-checkout-select-another-product') }}</button>
        <button type="submit" class="btn btn-outline-success btn-small" @click="save">{{ $t('ct-save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['config', 'e'],

  methods: {
    save() {
      this.e.clear();
      this.e.addValidation({
        continue_button: 'required|max:40',
        security_title: 'required|max:40',
        security_text: 'required|max:132',
        payment_button: 'required|max:40',
        thank_you_title: 'required|max:50',
        thank_you_text: 'required|max:2048',
        get_product_button: 'required|max:40'
      });
      if (this.e.validate(this.config.texts)) {
        this.$emit('save');
      } else {
        this.$nextTick(() => {
          document.querySelector('.is-invalid').focus();
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/TextsThreestepConfig.vue